// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__UysMw","productName":"Table_productName__21HNn"};